module.exports = __WEBPACK_EXTERNAL_MODULE_142__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/Loader","root":["openfl","display","Loader"],"commonjs":"openfl/display/Loader","commonjs2":"openfl/display/Loader"}
// module id = 142
// module chunks = 0